<template>
  <div>
    <v-card class="evaliv-card border-radius-xl elevation-10"
      :class="{ 'card-adeudo': isAdeudo, 'card-ok': !isAdeudo && isMembresiaEvaliv && !errorConexion }">
      <!-- Header -->
      <v-card-title class="evaliv-header px-6 py-4 d-flex align-center justify-space-between">
        <div class="d-flex align-center">
          <v-icon class="mr-3" :color="isAdeudo ? 'error' : 'primary'" size="28">mdi-shield-account-outline</v-icon>
          <span class="text-h6 font-weight-bold text-uppercase tracking-wide">Validación Evaliv</span>
        </div>
        <v-chip v-if="!loading" small :color="statusColor" class="font-weight-bold text-uppercase" text-color="white">
          {{ statusText }}
        </v-chip>
      </v-card-title>

      <v-divider></v-divider>

      <!-- Content -->
      <v-card-text class="pa-6 content-area position-relative">
        <!-- Loading State -->
        <v-fade-transition leave-absolute>
          <div v-if="loading" class="d-flex flex-column align-center justify-center py-8 content-state w-full">
            <v-progress-circular indeterminate color="primary" size="64" width="4"></v-progress-circular>
            <span class="mt-5 text-subtitle-1 text--secondary font-weight-medium">Verificando sistema de
              cobranza...</span>
          </div>
        </v-fade-transition>

        <v-fade-transition leave-absolute>
          <div v-if="!loading" class="content-state w-full d-flex flex-column align-center justify-center text-center">

            <!-- Connection Error -->
            <div v-if="errorConexion" class="d-flex flex-column align-center py-6 w-full">
              <v-icon color="error" size="80" class="mb-4 pulse-animation">mdi-wifi-strength-alert-outline</v-icon>
              <h3 class="text-h5 font-weight-bold error--text mb-2">Error de conexión</h3>
              <p class="text-subtitle-1 text--disabled mb-6">No se pudo obtener información desde EVALIV.</p>
              <v-btn color="error" outlined large class="rounded-lg px-8" @click="getEvalivInfo(cliente.dataClient)">
                <v-icon left>mdi-refresh</v-icon> Reintentar Validación
              </v-btn>
            </div>

            <!-- Membership Data -->
            <div v-else-if="isMembresiaEvaliv" class="d-flex flex-column align-center pt-2 pb-4 w-full">
              <div class="status-icon-wrapper mb-4" :class="isAdeudo ? 'error-bg' : 'success-bg'">
                <v-icon size="80" :color="isAdeudo ? 'error' : 'success'">
                  {{ isAdeudo ? 'mdi-alert-circle-outline' : 'mdi-check-circle-outline' }}
                </v-icon>
              </div>

              <h2 class="text-h4 font-weight-black mb-2" :class="isAdeudo ? 'error--text' : 'success--text'">
                {{ isAdeudo ? 'CLIENTE CON DEUDA' : 'SIN ADEUDO' }}
              </h2>

              <h3 class="text-h6 text--primary font-weight-medium mb-6">{{ clienteName }}</h3>

              <v-card outlined class="data-summary-card rounded-lg pa-4 background-soft text-left mx-auto"
                style="width: 100%; max-width: 500px;">
                <v-row no-gutters>
                  <v-col cols="6" class="border-right pr-4">
                    <div class="text-caption text-uppercase text--disabled font-weight-bold mb-1">Plan Actual</div>
                    <div class="text-subtitle-1 font-weight-medium text--primary">{{ planName || "Sin Plan" }}</div>
                  </v-col>
                  <v-col cols="6" class="pl-4" v-if="isAdeudo">
                    <div class="text-caption text-uppercase text--error font-weight-bold mb-1">Adeudo Total</div>
                    <div class="text-h6 font-weight-black error--text">${{ deuda }}</div>
                  </v-col>
                  <v-col cols="6" class="pl-4" v-else>
                    <div class="text-caption text-uppercase text--success font-weight-bold mb-1">Estado</div>
                    <div class="text-subtitle-1 font-weight-bold success--text">Al Corriente</div>
                  </v-col>
                </v-row>

                <v-row no-gutters class="mt-3 pt-3 border-top" v-if="isAdeudo && MesesAtraso > 0">
                  <v-col cols="12" class="d-flex align-center">
                    <v-icon size="18" color="warning" class="mr-2">mdi-calendar-alert</v-icon>
                    <span class="text-body-2 font-weight-medium text--secondary">Atraso correspondiente a: <strong
                        class="warning--text">{{ MesesAtraso }} Meses</strong></span>
                  </v-col>
                </v-row>
              </v-card>
            </div>

            <!-- No Membership Info -->
            <div v-else class="d-flex flex-column align-center py-6 w-full">
              <v-icon color="warning" size="80" class="mb-4">mdi-account-cancel-outline</v-icon>
              <h3 class="text-h5 font-weight-bold warning--text mb-2">Cliente sin membresía</h3>
              <p class="text-h6 font-weight-regular text--secondary mt-2">{{ clienteName }}</p>
            </div>

          </div>
        </v-fade-transition>
      </v-card-text>

      <v-divider></v-divider>

      <!-- Actions -->
      <v-card-actions class="pa-4 bg-lighten">
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" text large class="rounded-lg font-weight-bold px-6 mr-2" @click="cancelarAgregado">
          Cancelar
        </v-btn>
        <v-btn :color="actionButtonColor" large depressed class="rounded-lg font-weight-bold px-8 shadow-sm"
          @click="agregar" :disabled="loading">
          {{ actionButtonText }}
          <v-icon right>mdi-arrow-right</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
//const $ = require('jquery');
//window.$ = $;

import ApiEvaliv from "../../clases/ApiEvaliv.js";
import MembresiaPlan from "../../clases/Membresias/MembresiaPlan.js";
import moment from "moment"
export default {
  name: "Evaliv",
  components: {},
  props: ["cliente", "indexItem"],
  data() {
    return {
      loading: false,
      errorConexion: false,
      isAdeudo: false,
      isMembresiaEvaliv: false,
      MesesAtraso: 0,
      FechaMasAntigua: "",
      clienteName: "",
      planName: "",
      planes: "",
      deuda: 0,
    };
  },
  methods: {
    cancelarAgregado() {
      this.$emit("rechazarCliente", {
        index: this.indexItem,
      });
    },
    agregar() {
      let isAdeudo = false;
      if (this.isMembresiaEvaliv) {
        isAdeudo = this.isAdeudo;
      } else {
        isAdeudo = false;
      }
      this.$emit("aceptarCliente", {
        index: this.indexItem,
        player: this.cliente,
        isAdeudo: isAdeudo,
      });
    },
    async getEvalivInfo(cliente) {
      try {
        this.isAdeudo = false;
        this.loading = true;
        if (cliente?.ExtraData?.Membresia) {
          if (cliente?.ExtraData?.Membresia?.Plan) {
            let dataPlan = this.$pgsHelper.getById(
              this.planes,
              "Id",
              cliente?.ExtraData?.Membresia?.Plan
            );
            this.planName = dataPlan.Nomb;
          }
          let api = await ApiEvaliv.getInstance();
          let idMemdbresia = cliente?.ExtraData?.Membresia.Membresia;
          let adeudo = await api.get(
            "EVL-Acciones-getCobranzaAccion?tenant=" +
            "PCUN" +
            "&fechaHoy=" + moment().format("YYYY-MM-DD") +
            "&agrupado=true" +
            "&folioAccion=" +
            cliente.Apodo,
            {}
          ).catch(error => {
            if (error.code === 'ECONNABORTED') {
              this.errorConexion = true;
              this.loading = false;
            }
          });
          if (adeudo.status === 200) {
            this.errorConexion = false;
            if (adeudo.data.data.ok) {
              this.isMembresiaEvaliv = true;
              let totalDeuda = 0;
              if (adeudo.data.data.data.deuda) {
                let segmentos = adeudo.data.data.data.deuda;
                segmentos.forEach((seg) => {
                  this.FechaMasAntigua = seg.fechaPlan

                  totalDeuda += Number(seg.cantidadDeuda.C);
                });
              }
              if (totalDeuda <= 0) {
                this.isAdeudo = false;
                this.loading = false;
              } else {
                this.loading = false;
                this.isAdeudo = true;
                this.deuda = this.$pgsHelper.formatNumber(
                  totalDeuda
                );
                /*this.FechaMasAntigua	=adeudo.data.data.data.FechaMasAntigua
                this.MesesAtraso	=adeudo.data.data.data.MesesAtraso*/
              }
            } else {
              this.errorConexion = true;
              this.isAdeudo = false;
              this.isMembresiaEvaliv = true;
              this.loading = false;
            }
          } else {
            this.errorConexion = true;
            this.isAdeudo = true;
            this.isMembresiaEvaliv = true;
            this.loading = false;
          }
        }

        this.loading = false;
        this.$forceUpdate();
      } catch (e) {
        console.log(e);
        this.loading = false;
        this.errorConexion = true;
      }
    },
  },
  computed: {
    statusColor() {
      if (this.errorConexion) return 'error';
      if (!this.isMembresiaEvaliv) return 'warning';
      return this.isAdeudo ? 'error' : 'success';
    },
    statusText() {
      if (this.errorConexion) return 'Error';
      if (!this.isMembresiaEvaliv) return 'Sin Membresía';
      return this.isAdeudo ? 'Con Deuda' : 'Al Corriente';
    },
    actionButtonColor() {
      if (this.errorConexion || !this.isMembresiaEvaliv) return 'primary';
      return this.isAdeudo ? 'error' : 'success';
    },
    actionButtonText() {
      return 'Agregar a la reserva';
    },
    PlanesMembresias() {
      return MembresiaPlan.getMembresiasPlanList();
    },
  },
  watch: {},
  beforeMount: function () { },
  mounted() {
    this.clienteName = this.cliente.dataClient.text;
    this.planes = MembresiaPlan.getMembresiasPlanList();
    this.getEvalivInfo(this.cliente.dataClient);
  },
};
</script>

<style scoped>
.evaliv-card {
  overflow: hidden;
  transition: all 0.3s ease;
}

.card-adeudo {
  box-shadow: 0 8px 32px rgba(244, 67, 54, 0.15) !important;
  border-top: 4px solid var(--v-error-base, #f44336) !important;
}

.card-ok {
  border-top: 4px solid var(--v-success-base, #4caf50) !important;
}

.evaliv-header {
  background-color: var(--v-background-base, #f9fafb);
}

.tracking-wide {
  letter-spacing: 0.05em !important;
}

.content-area {
  min-height: 280px;
}

.content-state {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
}

.w-full {
  width: 100%;
}

.status-icon-wrapper {
  padding: 16px;
  border-radius: 50%;
  display: inline-flex;
}

.success-bg {
  background-color: rgba(76, 175, 80, 0.1);
}

.error-bg {
  background-color: rgba(244, 67, 54, 0.1);
  animation: pulse-red 2s infinite;
}

.background-soft {
  background-color: var(--v-background-base, #f5f7fa);
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.border-right {
  border-right: 1px solid rgba(0, 0, 0, 0.08);
}

.border-top {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
}

.bg-lighten {
  background-color: rgba(0, 0, 0, 0.02);
}

.shadow-sm {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

@keyframes pulse-red {
  0% {
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.4);
  }

  70% {
    box-shadow: 0 0 0 15px rgba(244, 67, 54, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
  }
}

.pulse-animation {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}
</style>
